module.exports = __webpack_public_path__ + "static/media/heliport.76e6763e.svg";